import { useState, useCallback } from "react";
import PropTypes from "prop-types";
import * as UserServices from "../../../../services/UserServices";

import { useTranslation } from "react-i18next";
import ChangePasswordForm from "./changePasswordForm.view";
import { ShowAlertDialog } from "@de-prado-dev/react-component-library";

const ChangePasswordFormContainer = ({ uuid, onCancel, onSuccess }) => {
  const { t } = useTranslation();

  const handleSubmit = async (values) => {
    try {
      if (values && uuid) {
        let result = await UserServices.updatePasswordUser(values, uuid);

        let title = "";
        let text = "";
        let icon = "";
        if (result) {
          title = t("forms.users.messages.changePassword.title");
          text = t("forms.users.messages.changePassword.success");
          icon = "success";
        } else {
          title = "Error";
          text = t("forms.users.messages.changePassword.error");
          icon = "error";
        }
        let okAction = () => {
          onSuccess();
        };
        ShowAlertDialog(title, text, icon, false, "OK", false, okAction);
      }
    } catch (error) {
      //console.log('Error', error);
    }
  };

  return <ChangePasswordForm onSubmit={handleSubmit} onBack={onCancel} />;
};

ChangePasswordFormContainer.propTypes = {
  t: PropTypes.any,
};

export default ChangePasswordFormContainer;
